let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (!subscribers[eventName]) return;

  // IMPORTANT:
  // If ANY subscriber throws, it can break the publisher's promise chain.
  // In Refresh/Dawn, cart quantity updates call publish(PUB_SUB_EVENTS.cartUpdate, ...)
  // inside a fetch().then() chain. A thrown error here will cause the cart update to
  // fall into .catch() and display "There was an error while updating your cart".
  //
  // We isolate subscribers so one bad listener can't break cart behaviour.
  subscribers[eventName].forEach((callback) => {
    try {
      callback(data);
    } catch (err) {
      console.error(`[pubsub] Error in subscriber for "${eventName}":`, err);
    }
  });
}